import * as React from 'react';
import { ListItemButton, ListItemText, List } from '@mui/material';
import SelectorListProps from '../interfaces/selectorListProps';

interface ExtendedSelectorListProps extends SelectorListProps {
  height?: number | string;
}

export const SelectorList: React.FC<ExtendedSelectorListProps> = ({items, selectedItem, onItemClick, height}) => {
    return (
        <List sx={{ backgroundColor: '#fff', borderRadius: '5px', height: height || '200px' , overflowY: 'auto' }}>
            {items?.map((item) => (
            <ListItemButton
                key={item.id}
                selected={selectedItem === item.id}
                onClick={(event) => onItemClick(item.id)}
            >
                <ListItemText
                    primary={item.name}
                    sx={{ textAlign: 'center' }}
                />
            </ListItemButton>
            ))}
        </List>
    );
}
